export const texts = {
  authError: 'Неверный логин или пароль',
  defaultError: 'Проблема при получении данных с сервера',
  requestError: 'Не удалось отправить запрос',
  requestSusses: 'Запрос отправлен',
  emptyData: 'Нет данных для отображения на данной странице',
  emptySearchResult: 'По данному поисковому запросу результаты не найдены',
  taskClosed: 'Задача закрыта',
  unableOpenFile: 'Не удалось открыть файл',
  404: `Простите нас =(

Мы не смогли открыть эту страницу...
Но попробуйте снова, вдруг получится.`,
};
